import { render, staticRenderFns } from "./TMResultsReportV2.vue?vue&type=template&id=39244804&scoped=true"
import script from "./TMResultsReportV2.vue?vue&type=script&lang=js"
export * from "./TMResultsReportV2.vue?vue&type=script&lang=js"
import style0 from "./TMResultsReportV2.vue?vue&type=style&index=0&id=39244804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39244804",
  null
  
)

export default component.exports